// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
export default {
  'components.cleanTextContextMenu.copy': '複製純淨文字',
  'components.cleanTextContextMenu.copied': '已複製純淨文字',
  'components.cleanTextContextMenu.failed': '無法複製文字，請重試。',
  'components.addToMattersPopover.selectMattersLabel': '選擇項目:',
  'components.addToMattersPopover.searchPlaceholder': '搜尋項目...',
  'components.addToMattersPopover.updateSuccess': '項目更新成功',
  'components.addToMattersPopover.updateError': '項目更新失敗',
  'components.billingRequiredOverlay.title': '需要處理帳單',
  'components.billingRequiredOverlay.manageBillingButton': '管理帳單',
  'components.chat.jsonResponseTitle': 'JSON 回應',
  'components.chat.dataOpenedInNewTab': '資料已在新分頁開啟',
  'components.chat.textResponseTitle': '文字回應',
  'components.chat.contentOpenedInNewTab': '內容已在新分頁開啟',
  'components.chat.fileOpenedInNewTab': '檔案已在新分頁開啟',
  'components.chat.failedToOpenNewTab': '開啟新分頁失敗',
  'components.chat.failedToFetchUrl': '擷取網址失敗:{message}',
  'components.chat.referenceDocumentFallback': '參考文件',
  'components.chat.sourcesCount': '來源({count})',
  'components.chat.referencesCount': '{count} 個參考資料',
  'components.chat.htmlContentTitle': 'HTML 內容',
  'components.chat.showMoreLines': '顯示更多({count} 行)',
  'components.chatWidget.waitingMessage.justAMoment': '請稍候...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': '正在為您擷取資料...',
  'components.chatWidget.waitingMessage.hangTight': '請稍等,我正在處理...',
  'components.chatWidget.waitingMessage.letMeCheck': '讓我確認一下...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': '馬上就好...',
  'components.chatWidget.closeChatAriaLabel': '關閉聊天',
  'components.chatWidget.openChatAriaLabel': '開啟聊天',
  'components.menuPanel.deleteConfirm.createdLabel': '建立時間：',
  'components.menuPanel.deleteSuccess': '歷史記錄項目已成功刪除',
  'components.menuPanel.deleteFailed': '刪除歷史記錄項目失敗',
  'components.menuPanel.searchHistoryButton': '搜尋歷史記錄',
  'components.menuPanel.historyLabel': '歷史記錄',
  'components.menuPanel.showAllButton': '顯示全部',
  'components.menuPanel.showFavoritesButton': '顯示收藏',
  'components.menuPanel.endOfListMessage': '－已到達末端－',
  'components.message.enhanceGpt.modalTitle': '優化 GPT 回覆',
  'components.message.enhanceGpt.successMessage': '已記錄新的回覆',
  'components.message.enhanceGpt.questionLabel': '問題：{question}',
  'components.message.enhanceGpt.answerLabel': '回答',
  'components.message.postback.clickedLabel': '已點擊：',
  'components.message.postback.chatbotButtonFallback': '聊天機器人按鈕',
  'components.message.locationLabel': '位置',
  'components.message.stickerLabel': '貼圖',
  'components.message.audiosLabel': '音訊',
  'components.message.imagesLabel': '圖片',
  'components.message.videosLabel': '影片',
  'components.msgViewer.fromLabel': '寄件者：',
  'components.msgViewer.toLabel': '收件者：',
  'components.msgViewer.attachmentsLabel': '附件：',
  'components.pdfViewerWithHighlight.renderError': 'PDF 渲染失敗',
  'components.promptSelector.copySuccess': '提示詞已複製！',
  'components.promptSelector.copyError': '複製提示詞失敗',
  'components.promptSelector.noResultsFiltered': '找不到符合篩選條件的提示詞',
  'components.promptSelector.startTyping': '開始輸入以搜尋提示詞',
  'components.promptSelector.promptLoaded': '提示詞已載入聊天輸入框！',
  'components.promptSelector.untitledPrompt': '未命名提示詞',
  'components.promptSelector.actionPlaceholder': '動作',
  'components.promptSelector.actionOption.summarise': '摘要',
  'components.promptSelector.actionOption.review': '審閱',
  'components.promptSelector.actionOption.amend': '修訂',
  'components.promptSelector.actionOption.draft': '草擬',
  'components.promptSelector.actionOption.redFlagging': '風險標記',
  'components.promptSelector.audiencePlaceholder': '適用對象',
  'components.promptSelector.audienceOption.personal': '個人',
  'components.promptSelector.audienceOption.group': '群組',
  'components.promptSelector.audienceOption.public': '公開',
  'components.promptSelector.selectPromptHint': '選擇提示詞以載入輸入框',
  'components.promptSelector.usePromptButton': '使用提示詞',
  'components.promptSelector.authorLabel': '作者',
  'components.promptSelector.promptLabel': '提示詞',
  'components.promptSelector.tagsLabel': '標籤',
  'components.promptSelector.documentsAttached': '將附加 {count} 份文件',
  'components.questionListSelection.untitledQuestionList': '（未命名）',
  'components.questionListSelection.questionCount': '{count} 個問題',
  'components.questionListSelection.accessPublicTag': '公開',
  'components.questionListSelection.accessFirmTag': '事務所',
  'components.questionListSelection.accessGroupTag': '私人群組',
  'components.questionListSelection.viewLess': '收合顯示',
  'components.questionListSelection.viewAll': '顯示全部',
  'components.questionListSelection.whatsNewButton': '最新消息',
  'components.questionListSelection.tourTooltip': '進行導覽',
  'components.questionListSelection.tourButton': '導覽',
  'components.questionListSelection.sortMostPopular': '排序：最受歡迎',
  'components.questionListSelection.sortNameAsc': '排序：名稱 A-Z',
  'components.questionListSelection.sortNameDesc': '排序：名稱 Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': '依適用對象篩選',
  'components.questionListSelection.audienceOptionPersonal': '個人',
  'components.questionListSelection.audienceOptionPublic': '公開',
  'components.questionListSelection.filterByAuthorPlaceholder': '依作者篩選',
  'components.reference.unknownAuthor': '未知',
  'components.reference.timeAgo.justNow': '剛剛',
  'components.reference.timeAgo.minutesAgo': '{count, plural, other {# 分鐘前}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, other {# 小時前}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, other {# 天前}}',
  'components.reference.openCellDetails': '開啟儲存格詳細資料',
  'components.reference.answerLabel': '答案： ',
  'components.reference.explanationLabel': '說明',
  'components.reference.verifiedLabel': '已驗證',
  'components.reference.verifyLabel': '驗證',
  'components.reference.pleaseEnterComment': '請輸入留言',
  'components.reference.commentAddedSuccess': '留言新增成功',
  'components.reference.failedToAddComment': '新增留言失敗',
  'components.reference.commentUpdatedSuccess': '留言更新成功',
  'components.reference.updateOwnCommentsOnly': '您只能更新自己的留言',
  'components.reference.failedToUpdateComment': '更新留言失敗',
  'components.reference.commentDeletedSuccess': '留言刪除成功',
  'components.reference.deleteOwnCommentsOnly': '您只能刪除自己的留言',
  'components.reference.failedToDeleteComment': '刪除留言失敗',
  'components.reference.deleteComment.title': '刪除留言',
  'components.reference.deleteComment.description': '您確定要刪除這則留言嗎？',
  'components.reference.addCommentPlaceholder': '新增留言...',
  'components.reference.cellsSelected': '{count, plural, other {已選取 # 個儲存格。}}',
  'components.reference.selectCellAriaLabel': '選取儲存格',
  'components.reference.selectQuestionRowAriaLabel': '選取問題列',
  'components.reference.selectDocumentColumnAriaLabel': '選取文件欄',
  'components.reference.selectDocumentRowAriaLabel': '選取文件列',
  'components.reference.selectQuestionColumnAriaLabel': '選取問題欄',
  'components.reference.documentsHeader': '文件',
  'components.reference.addRow': '新增列',
  'components.reference.addColumn': '新增欄',
  'components.reference.inverse': '反轉',
  'components.reference.showAllColumns': '顯示所有欄',
  'components.reference.showAllRows': '顯示所有列',
  'components.reference.resetView': '重設檢視',
  'components.reference.summaryView': '摘要檢視',
  'components.reference.exactQuote': '原文引用',
  'components.reference.exactQuoteView': '原文引用檢視',
  'components.reference.detailedView': '詳細檢視',
  'components.reference.exitSelectMode': '退出',
  'components.reference.chatWithSelectedOutput': '與已選取的輸出對話',
  'components.reference.selectCells': '選取儲存格',
  'components.referencePopover.fileLinkUnavailable': '檔案連結無法使用',
  'components.referencePopover.failedToOpenNewTab': '開啟新分頁失敗',
  'components.referencePopover.failedToOpenFile': '開啟檔案失敗',
  'components.referencePopover.openInNewTab': '在新分頁開啟文件 ↗',
  'components.rightContent.organisationSwitcher.switching': '正在切換組織...',
  'components.rightContent.organisationSwitcher.switchSuccess': '組織切換成功',
  'components.rightContent.organisationSwitcher.switchNoToken': '切換組織未回傳新的權杖',
  'components.rightContent.organisationSwitcher.switchError': '切換組織失敗',
  'components.rightContent.organisationSwitcher.unknownOrg': '未知組織',
  'components.rightContent.organisationSwitcher.defaultLabel': '組織',
  'components.rightContent.organisationSwitcher.tooltipFallback': '切換組織',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': '聯絡我們',
  'components.rightContent.reportBug.label': '回報問題',
  'components.rightContent.reportBug.modalDescription': '請填寫以下表單，告訴我們您遇到的狀況。',
  'components.rightContent.reportBug.contactSectionTitle': '聯絡資訊',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': '問題描述',
  'components.rightContent.reportBug.environmentSectionTitle': '環境資訊',
  'components.rightContent.reportBug.namePlaceholder': '請輸入您的姓名',
  'components.rightContent.reportBug.nameRequired': '請輸入您的姓名',
  'components.rightContent.reportBug.emailLabel': '電子郵件',
  'components.rightContent.reportBug.emailPlaceholder': '請輸入您的電子郵件',
  'components.rightContent.reportBug.emailRequired': '請輸入您的電子郵件',
  'components.rightContent.reportBug.emailInvalid': '請輸入有效的電子郵件地址',
  'components.rightContent.reportBug.locationLabel': '問題發生於哪個位置？',
  'components.rightContent.reportBug.locationPlaceholder': '選擇功能',
  'components.rightContent.reportBug.locationRequired': '請說明問題發生的位置',
  'components.rightContent.reportBug.descriptionLabel': '描述問題',
  'components.rightContent.reportBug.descriptionRequired': '請描述問題',
  'components.rightContent.reportBug.filesLabel': '螢幕截圖或錄影',
  'components.rightContent.reportBug.uploadText': '點擊或拖曳以上傳',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': '移除 {fileName}',
  'components.rightContent.reportBug.deviceLabel': '裝置',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': '請說明您的裝置',
  'components.rightContent.reportBug.osLabel': '作業系統及版本',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': '請說明您的作業系統',
  'components.rightContent.reportBug.browserLabel': '瀏覽器',
  'components.rightContent.reportBug.browserPlaceholder': '選擇瀏覽器',
  'components.rightContent.reportBug.browserRequired': '請說明您使用的瀏覽器',
  'components.rightContent.reportBug.submitSuccess': '問題回報已成功送出！',
  'components.rightContent.reportBug.submitError': '問題回報送出失敗，請再試一次。',
  'components.rightContent.reportBug.invalidFileType': '僅可上傳圖片或影片檔案！',
  'components.rightContent.reportBug.fileUploadSuccess': '檔案「{fileName}」上傳成功！',
  'components.rightContent.reportBug.fileUploadError': '檔案上傳失敗',
  'components.rightContent.reportBug.page.home': '首頁',
  'components.rightContent.reportBug.page.chat': '聊天',
  'components.rightContent.reportBug.page.composer': '撰寫器',
  'components.rightContent.reportBug.page.review': '審閱',
  'components.rightContent.reportBug.page.reference': '參考資料',
  'components.rightContent.reportBug.page.files': '檔案',
  'components.rightContent.reportBug.page.userProfile': '使用者個人資料',
  'components.rightContent.reportBug.page.other': '其他',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': '其他',
  'components.rightContent.receiptModal.title': '感謝您',
  'components.rightContent.receiptModal.description': '您的回報已送出。',
  'components.scribe.clickToStartRecording': '點擊以開始錄音',
  'components.scribe.failedToGetAuthToken': '無法取得驗證權杖',
  'components.scribe.failedToStartRecording': '無法開始錄音',
  'components.searchPdfViewerWithHighlight.renderError': '無法呈現 PDF',
  'components.themeToggle.themeSectionLabel': '主題',
  'components.themeToggle.themeTeal': '🌊 藍綠色',
  'components.themeToggle.themeMaroon': '🍷 栗紅色',
  'components.themeToggle.modeSectionLabel': '模式',
  'components.themeToggle.lightMode': '淺色',
  'components.themeToggle.darkMode': '深色',
  'components.themeToggle.themeSettingsTooltip': '主題設定',
  'components.billingRequiredOverlay.defaultMessage':
    '在繼續此操作之前,您的組織帳單需要處理。請聯絡您的組織管理員。',
  'components.reference.matrixIdRequired':
    '需要 Matrix ID。請確認已將 matrixId 屬性傳遞給 Reference 元件。',
  'components.chatWidget.processingTooltip': '處理完成後即可使用聊天功能',
  'components.chatWidget.messageCopied': '訊息已複製！',
  'components.chatWidget.copyMessageFailed': '複製訊息失敗',
  'components.chatWidget.header.title': '聊天',
  'components.chatWidget.emptyState.title': '有什麼我可以協助的？',
  'components.chatWidget.inputPlaceholder': '輸入訊息...',
  'components.chatWidget.showMoreLines': '顯示更多（{count} 行）',
  'components.chatWidget.invalidFileUrl': '檔案網址無效或遺失',
  'components.chatWidget.fileDownloadedSuccessfully': '檔案下載成功',
  'components.chatWidget.fileDownloadFailed': '檔案下載失敗：{message}',
  'components.chatWidget.unnamedFile': '檔案',
  'components.chatWidget.attachmentImageAlt': '附件',
  'components.checklistCard.heading': '檢查清單',
  'components.downloadLoadingMask.downloading': '下載中...',
  'components.emlViewer.fromLabel': '寄件者：',
  'components.emlViewer.toLabel': '收件者：',
  'components.emlViewer.ccLabel': '副本：',
  'components.emlViewer.dateLabel': '日期：',
  'components.emlViewer.attachmentsLabel': '附件：',
  'components.filesSidePanel.favoritesButton': '我的最愛',
  'components.filesSidePanel.historyButton': '歷史記錄',
  'components.filesSidePanel.untitledPlaceholder': '（未命名）',
  'components.filesSidePanel.membersPopoverTitle': '成員',
  'components.filesSidePanel.ownerTag': '擁有者',
  'components.filesSidePanel.modifyGroupTooltip': '修改群組',
  'components.filesSidePanel.privateGroupWarningTooltip': '安全性較低：您的群組成員皆可檢視。',
  'components.filesSidePanel.firmWideWarningTooltip': '安全性極低：貴事務所全體皆可檢視。',
  'components.filesSidePanel.publicWarningTooltip': '安全性極低：所有人皆可檢視。',
  'components.filesSidePanel.sortByDateLabel': '依日期排序（新到舊）',
  'components.filesSidePanel.sortAlphabeticallyLabel': '依字母排序（A-Z）',
  'components.gettingStartedTour.insiderHero.openLinkLabel': '開啟 A&GEL Insider',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': '學習新工具需要時間',
  'components.gettingStartedTour.insiderHero.basicsCard.copy': '從第一天起您所需的一切。',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': '從基礎開始',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': '了解更多',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy': '最新發布與更新內容。',
  'components.gettingStartedTour.insiderHero.marinaAlt': '碼頭天際線',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': '精選文章',
  'components.gettingStartedTour.insiderHero.filesUpload.title': '檔案上傳',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': '查看更多',
  'components.gettingStartedTour.allCompleted.redoButton': '重新導覽',
  'components.gettingStartedTour.heading': '新手導覽',
  'components.gettingStartedTour.tourStyles.stepIndicator': '第 {current} 步，共 {total} 步',
  'components.gettingStartedTour.tourStyles.nextDefault': '下一步 →',
  'components.gettingStartedTour.chatTour.step2.nextLabel': '關閉並繼續 →',
  'components.gettingStartedTour.chatTour.completeModal.title': '做得好！',
  'components.gettingStartedTour.tourComplete.completeButton': '完成',
  'components.gettingStartedTour.tourComplete.continueButton': '繼續前往 {title} →',
  'components.gettingStartedTour.playbookTour.completeModal.title': '做得好！',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': '開啟中…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': '開啟範例 →',
  'components.gettingStartedTour.playbookTour.step2.item1': '• 共同智慧財產權（第 17 條）',
  'components.gettingStartedTour.playbookTour.step2.item2': '• 新增 14 天補救期（第 8 條）',
  'components.gettingStartedTour.playbookTour.step2.item3': '• 縮小競業禁止範圍（第 27 條）',
  'components.gettingStartedTour.playbookTour.step3.title': '點選「傳送」以產生修訂內容。',
  'components.gettingStartedTour.reviewTour.completeModal.title': '太厲害了！',
  'components.gettingStartedTour.reviewTour.step4.title': '選擇分類以整理您的清單。',
  'components.gettingStartedTour.reviewTour.step9.title': '儲存您的清單，以便套用於文件。',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': '完成',
  'components.gettingStartedTour.scribeTour.completeModal.title': '做得好！',
  'components.gettingStartedTour.scribeTour.step2.title': '語言已設定為「自動偵測」。',
  'components.gettingStartedTour.scribeTour.step7.title': '點選「編輯」以修改逐字稿。',
  'components.gettingStartedTour.scribeTour.step7.text': '您的變更會以金色顯示。',
  'components.gettingStartedTour.scribeTour.step8.title': '點選「儲存」以保留您的變更。',
  'components.gettingStartedTour.scribeTour.step8.text': '儲存前，您的編輯內容會以金色顯示。',
  'components.gettingStartedTour.searchTour.completeModal.title': '做得好！',
  'components.gettingStartedTour.tourButton.label': '導覽',
  'components.gettingStartedTour.tourCompleteModal.features.chat': '在「聊天」中提出問題',
  'components.gettingStartedTour.tourCompleteModal.features.search': '跨文件搜尋',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': '使用 Scribe 進行轉錄',
  'components.gettingStartedTour.tourCompleteModal.features.review': '使用 Review 進行分析',
  'components.gettingStartedTour.tourCompleteModal.progressText': '已完成 5 項功能中的 5 項',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': '開始使用 A&GEL →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': '需要協助嗎？請前往',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': '使用指南',
  'components.lLMMetrics.status.fast': '快速',
  'components.lLMMetrics.status.slow': '緩慢',
  'components.lLMMetrics.status.busy': '忙碌',
  'components.lLMMetrics.status.pending': '待處理',
  'components.lLMMetrics.status.loading': '載入中',
  'components.lLMMetrics.metricBox.defaultChartLabel': '數值',
  'components.management.passwordModal.usernameColumn': '使用者名稱',
  'components.management.passwordModal.passwordColumn': '密碼',
  'components.menuPanel.untitledItem': '(未命名)',
  'components.menuPanel.renameFailed': '重新命名失敗',
  'components.menuPanel.deleteConfirm.title': '刪除歷史項目',
  'components.whatsNewModal.title': '最新功能',
  'components.whatsNewModal.intro': '我們新增了多項功能，協助您提升文件審閱流程：',
  'components.whatsNewModal.feature1.title': '篩選功能優化：',
  'components.whatsNewModal.feature1.description':
    '新增對象與作者篩選條件，協助您更快找到問題清單。',
  'components.whatsNewModal.feature2.title': '臨時問題：',
  'components.whatsNewModal.feature2.description': '以更靈活的方式即時新增問題。',
  'components.whatsNewModal.feature3.title': '介面優化：',
  'components.whatsNewModal.feature3.description': '更簡潔直觀的介面，方便管理您的 {featureName}。',
  'components.whatsNewModal.upcomingFeatures.title': '即將推出的功能',
  'components.whatsNewModal.upcomingFeatures.description':
    '敬請期待更多更新，包括協作審閱與進階 AI 分析功能。',
  'components.user.uidLabel': '使用者 ID',
  'components.user.idCopiedMessage': 'ID 已複製！',
  'components.file.manager.fetchGroupError': '取得群組失敗：{message}',
  'components.file.manager.fetchFilesError': '取得檔案失敗：{message}',
  'components.file.manager.breadcrumbRoot': '根目錄',
  'components.file.manager.breadcrumbBackUpLevel': '返回上一層',
  'components.file.manager.searchPlaceholder': '搜尋檔案或資料夾',
  'components.file.manager.uploadFileButton': '上傳檔案',
  'components.file.manager.createFolderButton': '建立資料夾',
  'components.file.manager.enterButton': '進入',
  'components.file.manager.deleteFolderButton': '刪除資料夾',
  'components.file.manager.deleteFileButton': '刪除檔案',
  'components.file.manager.uploadedByTime': '上傳者：{username}，上傳時間：{createdAt}',
  'components.file.manager.folderNamePlaceholder': '資料夾名稱',
  'components.file.filePreview.cannotPreview': '此檔案類型無法預覽',
  'components.file.documentSelector.sortNameAsc': '名稱（A-Z）',
  'components.file.documentSelector.sortNameDesc': '名稱（Z-A）',
  'components.file.documentSelector.sortNewestFirst': '最新在前',
  'components.file.documentSelector.sortOldestFirst': '最舊在前',
  'components.file.documentSelector.favourites': '我的最愛',
  'components.file.documentSelector.selectedCount': '已選取（{count}）：',
  'components.file.documentSelector.selectAllFilesInFolder': '選取 {folderName} 中的所有檔案',
  'components.file.documentSelector.noFiles': '沒有檔案',
  'components.file.documentSelector.folderAlt': '資料夾',
  'components.file.documentSelector.fileAlt': '檔案',
  'components.file.documentSelector.selectDocuments': '選擇文件',
  'components.file.documentSelector.selectOkText': '選擇',
  'components.file.fileTree.uploadFailed': '{fileName} 上傳失敗',
  'components.file.fileTree.clickOrDragToUpload': '點選或拖曳以上傳',
  'components.file.fileTree.noFilesUploadedOrSelected': '尚未上傳或選取任何檔案。',
  'components.file.selectContext.cannotDeleteDefaultContext':
    '無法刪除預設情境。請先將其他情境設為預設。',
  'components.file.selectContext.contextDeleted': '情境已刪除',
  'components.file.selectContext.deleteContextFailed': '刪除情境失敗',
  'components.file.selectContext.enterContextNameWarning': '請輸入情境名稱',
  'components.file.selectContext.contextCreated': '情境已建立',
  'components.file.selectContext.cannotUnsetDefaultContext':
    '無法取消預設情境。請先將其他情境設為預設。',
  'components.file.selectContext.contextUpdated': '情境已更新',
  'components.file.selectContext.createContextFailed': '建立情境失敗',
  'components.file.selectContext.updateContextFailed': '更新情境失敗',
  'components.file.selectContext.selectContextPresetPlaceholder': '選擇預設情境',
  'components.file.selectContext.defaultLabel': '（預設）',
  'components.file.selectContext.deleteContextConfirmTitle': '要刪除此情境嗎？',
  'components.file.selectContext.deleteContextConfirmDescription': '此操作無法復原。',
  'components.file.selectContext.addNewContextTooltip': '新增情境',
  'components.file.selectContext.modifyContextInfoTooltip': '修改情境資訊',
  'components.file.selectContext.newContextLabel': '新增情境',
  'components.file.selectContext.editContextLabel': '編輯情境',
  'components.file.selectContext.contextTitlePlaceholder': '情境標題',
  'components.file.selectContext.setAsDefaultLabel': '設為預設',
  'components.file.selectContext.contextSelectionTitle': '情境選擇',
  'components.file.selectContext.noContextSelected': '尚未選擇情境',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    '如果您想更進一步，這裡有進階功能。',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': '最新消息',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    '將完整的電子郵件檔案（包含附件）上傳至 A&GEL，並像處理其他文件一樣使用它們。',
  'components.gettingStartedTour.allCompleted.title': '您已完成完整的 A&GEL 導覽！',
  'components.gettingStartedTour.chatTour.step1.title':
    '我們已為您載入範例保密協議（NDA）。點擊「內容」即可查看。',
  'components.gettingStartedTour.chatTour.step1.text':
    '您可以在這裡管理 A&GEL 回答時所參考的文件。',
  'components.gettingStartedTour.chatTour.step2.title': '這是您已載入的文件。',
  'components.gettingStartedTour.chatTour.step2.text':
    '您可以上傳檔案或從「保存庫」中選擇。準備好後即可關閉此面板。',
  'components.gettingStartedTour.chatTour.step3.title':
    '我們已為您準備好一個問題。點擊「傳送」以詢問有關該保密協議的內容。',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay': '此協議中的保密義務是什麼？',
  'components.gettingStartedTour.chatTour.step4.title':
    '很棒的回答！現在點擊引用編號（例如 [1]）即可查看來源文件。',
  'components.gettingStartedTour.chatTour.step4.text': '引用會連結回 AI 所使用文件的確切部分。',
  'components.gettingStartedTour.chatTour.completeModal.description':
    '您在「對話」中提出了第一個問題，並獲得了附有引用的答案。',
  'components.gettingStartedTour.tourComplete.progressText':
    '已完成 5 項功能中的 {completedCount} 項',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    '您已使用 Workstudio 套用修訂。',
  'components.gettingStartedTour.playbookTour.step1.title':
    '我們已載入一份需要修訂的範例供應商協議。',
  'components.gettingStartedTour.playbookTour.step1.text':
    '您是供應商（Pand.ai），正向客戶要求更優惠的條款。',
  'components.gettingStartedTour.playbookTour.step2.title': '我們已草擬 3 項修訂請求：',
  'components.gettingStartedTour.playbookTour.step2.text':
    '多步驟模式會平行處理每一項，以更快獲得結果。',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL 會顯示追蹤修訂，您可以接受、拒絕或下載。',
  'components.gettingStartedTour.playbookTour.step4.title': '以下是 A&GEL 根據您的提示草擬的修訂。',
  'components.gettingStartedTour.playbookTour.step4.text': '每張卡片皆顯示原始文字與建議的變更。',
  'components.gettingStartedTour.playbookTour.step5.title': '檢視此修訂並選擇接受或拒絕。',
  'components.gettingStartedTour.playbookTour.step5.text': '您稍後可以對其餘項目重複此操作。',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    '您已建立問題清單並用它審閱了文件。',
  'components.gettingStartedTour.reviewTour.step1.title':
    '「審閱」使用問題清單，跨多份文件回答您的問題。',
  'components.gettingStartedTour.reviewTour.step1.text': '您可以建立自己的問題清單，或使用現有的。',
  'components.gettingStartedTour.reviewTour.step2.title': '依類別瀏覽預建的問題清單。',
  'components.gettingStartedTour.reviewTour.step3.title':
    '來建立您自己的清單吧。點擊這裡以開始建立新的問題清單。',
  'components.gettingStartedTour.reviewTour.step5.title':
    '以下是一些範例問題，已新增至您的清單並成為可編輯的列。',
  'components.gettingStartedTour.reviewTour.step6.title':
    '您的問題會以可編輯的列顯示於此。您可以隨時移除，或新增區段以進行分組。',
  'components.gettingStartedTour.reviewTour.step7.title': '說明此清單的用途——依您的需求量身打造。',
  'components.gettingStartedTour.reviewTour.step8.title':
    '調整 AI 回答的方式——語氣、格式、詳細程度。',
  'components.gettingStartedTour.reviewTour.step10.title': '我們已載入一些範例文件供您試用。',
  'components.gettingStartedTour.reviewTour.step10.text': '您的問題清單已可對這些文件執行。',
  'components.gettingStartedTour.reviewTour.step11.title': '點擊「提交」以對所有文件執行審閱。',
  'components.gettingStartedTour.reviewTour.step12.title':
    '每一列代表一個問題，每一欄代表一份文件。答案會自動擷取。',
  'components.gettingStartedTour.reviewTour.step13.title': '點擊任何答案即可查看其確切來源。',
  'components.gettingStartedTour.reviewTour.step14.title':
    '點擊引用編號即可跳至來源文件中的確切段落。',
  'components.gettingStartedTour.reviewTour.step15.title':
    '這就是完整的「審閱」流程——來源永遠只需點擊一下即可查看。您已完成！',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    '您已使用 Scribe 轉錄音訊。',
  'components.gettingStartedTour.scribeTour.step1.title': '選擇您將用此轉錄檔做什麼用途。',
  'components.gettingStartedTour.scribeTour.step1.text':
    '這有助於 A&GEL 格式化輸出內容。目前已選取「會議記錄」。',
  'components.gettingStartedTour.scribeTour.step2.text':
    '您也可以啟用即時翻譯，以即時查看翻譯內容。',
  'components.gettingStartedTour.scribeTour.step3.title': '點擊錄音按鈕，或上傳現有的音訊檔案。',
  'components.gettingStartedTour.scribeTour.step4.title': '準備儲存轉錄檔時，點擊「停止」。',
  'components.gettingStartedTour.scribeTour.step5.title':
    '為您的轉錄檔輸入名稱，然後點擊「儲存」。',
  'components.gettingStartedTour.scribeTour.step6.title':
    '點擊任一行轉錄文字，即可從該處開始播放音訊。',
  'components.gettingStartedTour.searchTour.completeModal.description':
    '您已跨文件搜尋並找到相關條款。',
  'components.gettingStartedTour.searchTour.step1.title': '我們已為您準備好搜尋查詢。',
  'components.gettingStartedTour.searchTour.step1.text':
    '點擊「搜尋」或按 Enter 鍵以尋找相符的條款。',
  'components.gettingStartedTour.searchTour.step2.title':
    '這是來自該保密協議的相符結果。點擊文件即可查看其中所有相符內容。',
  'components.gettingStartedTour.searchTour.step3.title': '點擊任一片段即可跳至文件中的該區段。',
  'components.gettingStartedTour.searchTour.step3.text':
    '左側顯示相符的摘錄。右側則是標示關鍵字的完整文件。',
  'components.gettingStartedTour.tourCompleteModal.features.playbook': '在 Workstudio 中套用修訂',
  'components.gettingStartedTour.tourCompleteModal.title': '一切就緒！',
  'components.gettingStartedTour.tourCompleteModal.subtitle': '您已完成 A&GEL 導覽，並學會如何：',
  'components.management.passwordModal.createHeader': '您已成功建立使用者，憑證如下：',
  'components.management.passwordModal.emailChangeHeader':
    '您已成功變更使用者電子郵件。新的憑證如下：',
  'components.management.passwordModal.changePasswordNotice': '*使用者首次登入後必須變更密碼',
  'components.menuPanel.deleteConfirm.content': '您確定要刪除此歷史記錄項目嗎？此操作無法復原。',
  'components.appShell.logoutMenuItem': '登出',
  'components.appShell.unauthorized.title': '此頁面不適合您存取',
  'components.appShell.unauthorized.backHome': '返回首頁',
  'components.appShell.promptLibrary.title': '提示詞庫',
  'components.appShell.promptLibrary.noPromptsAvailable': '暫無可用提示詞',
  'components.appShell.promptLibrary.copyTooltip': '複製提示詞內容',
  'components.appShell.promptLibrary.untitledPrompt': '未命名提示詞',
  'components.appShell.promptLibrary.copiedMessage': '提示詞已複製到剪貼簿！',
  'components.appShell.clipboard.title': '剪貼簿',
  'components.appShell.clipboard.copiedMessage': '已複製！',
  'components.appShell.notFound.title': '此頁面不存在',
  'components.gettingStartedTour.tourTask.chat.title': '對話',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 分鐘',
  'components.gettingStartedTour.tourTask.search.title': '搜尋',
  'components.gettingStartedTour.tourTask.search.duration': '~1 分鐘',
  'components.gettingStartedTour.tourTask.scribe.title': '錄音',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 分鐘',
  'components.gettingStartedTour.tourTask.review.title': '審閱',
  'components.gettingStartedTour.tourTask.review.duration': '~3 分鐘',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 分鐘',
  'components.matrixPolling.processingStoppedMessage': '處理已停止',
  'components.matrixPolling.stopProcessingFailedMessage': '停止處理失敗',
  'components.appShell.noResponseError': '無回應！請重試。',
  'components.appShell.requestError': '請求錯誤，請重試。',
  'components.appShell.requestFailedError': '請求失敗！',
  'components.composerService.socketErrorPrefix': '錯誤：{message}',
  'components.composerService.sessionDisconnected': 'Composer 工作階段因另一個連線而中斷',
  'components.fileViewerWithToken.retrieveFailedError': '取得檔案失敗',
  'components.languageSwitcher.switchLanguageTooltip': '切換語言',
  'components.crossOrgBadge.sharedByLabel': '分享者：{orgName}',
  'components.crossOrgBadge.externalOrganization': '外部機構',
  'components.file.sharePoint.fromComputer': '從此電腦',
  'components.file.sharePoint.fromSharePoint': '從 SharePoint / OneDrive',
  'components.file.sharePoint.orAddFromSharePoint': '或從 SharePoint / OneDrive 新增',
  'components.file.sharePoint.account': 'Microsoft 帳戶',
  'components.file.sharePoint.useDifferentAccount': '使用其他帳戶',
  'components.file.sharePoint.disconnect': '中斷連線',
  'components.file.sharePoint.disconnectConfirm': '要從 A&GEL 中斷您的 Microsoft 帳戶連線嗎？',
  'components.file.sharePoint.disconnected': '已中斷 Microsoft 帳戶連線。',
  'components.file.sharePoint.popupBlocked':
    '請允許 A&GEL 開啟彈出視窗，以便從 SharePoint 選取檔案。',
  'components.file.sharePoint.consentDeniedTitle': 'SharePoint 存取未獲核准',
  'components.file.sharePoint.consentDenied':
    'SharePoint 存取未獲核准。如果您的機構需要 IT 管理員核准，請聯絡 IT 管理員核准 A&GEL。',
  'components.file.sharePoint.copyApprovalLink': '複製核准連結給 IT 管理員',
  'components.file.sharePoint.approvalLinkCopied': '核准連結已複製。',
  'components.file.sharePoint.connectFailed': '無法連線到 Microsoft，請再試一次。',
  'components.file.sharePoint.reconnect': '請重新連線您的 Microsoft 帳戶。',
  'components.file.sharePoint.unsupportedType': '此處不支援 {name} 的檔案類型。',
  'components.file.sharePoint.tooLarge': '{name} 太大（上限 {max} MB）。',
  'components.file.sharePoint.rejected': '無法新增 {name}。',
  'components.file.sharePoint.downloadFailed':
    '無法從 SharePoint 取得 {name}。請再試一次，或從電腦上傳。',
  'components.file.sharePoint.folderTooLarge':
    '此資料夾太大，無法一次匯入（上限 {max} 個檔案）。請選擇較小的資料夾。',
  'components.file.sharePoint.chooserTitle': '挑選檔案',
  'components.file.sharePoint.chooserMyFiles': '我的檔案',
  'components.file.sharePoint.chooserShared': '共用',
  'components.file.sharePoint.chooserFollowedSites': '已追蹤的網站',
  'components.file.sharePoint.chooserSearch': '搜尋網站',
  'components.file.sharePoint.chooserName': '名稱',
  'components.file.sharePoint.chooserEmpty': '您尚未追蹤任何網站。請在上方搜尋網站。',
  'components.file.sharePoint.chooserLocked':
    '僅顯示您追蹤或搜尋到的網站。如需瀏覽所有網站，請向 IT 管理員申請核准 A&GEL。',
  'components.file.sharePoint.chooserLoading': '載入中…',
  'components.file.sharePoint.chooserSelect': '選取',
  'components.file.sharePoint.chooserCancel': '取消',
};
